import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'om-barnet';
        case 'om-barnet':
            return 'sygeforsikring';
        case 'sygeforsikring':
            return 'dato';
        case 'dato':
            return 'skadested';
        case 'skadested':
            if (getValueOrDefault(formConfig, formValues, 'lossLocation').value === 'Ja') {
                return 'hvordan-skete-skaden';
            } else {
                return 'paa-arbejde';
            }
        case 'paa-arbejde':
            return 'hvordan-skete-skaden';
        case 'hvordan-skete-skaden':
            return 'beskriv-skaden';
        case 'beskriv-skaden':
            return 'tandvaelger';
        case 'tandvaelger':
            return 'tandlaegeklinik';
        case 'tandlaegeklinik':
            return 'dokumentation';
        case 'dokumentation':
            return 'andet-selskab';
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            } else {
                return 'om-dig';
            }
        case 'hvilket-selskab':
            return 'om-dig';
        case 'om-dig':
            return 'resume';
        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
